import {
    Component
} from "../../../../../../sedestral/framework/interface/component/Component";
import * as s from "../website-content.scss";
import * as r from "./website-content-guide.scss";
import {WebsitePostsService} from "../../../../../../services/website/WebsitePostsService";
import {WebsitePostType} from "../../../../../../models/website/posts/WebsitePostType";
import {
    LoaderObjectBlockComponent
} from "../../../../../components/global/loader/objects/block/LoaderObjectBlockComponent";
import {LoaderLightComponent} from "../../../../../components/global/loader/light/LoaderLightComponent";
import {IWebsitePostIncoming} from "../../../../../../models/website/posts/IWebsitePostIncoming";
import {WebsiteBlackGuideComponent} from "../../black/guide/WebsiteBlackGuideComponent";
import {Network} from "../../../../../../network/Network";
import {WebsiteGuideParams} from "../../black/guide/types/WebsiteGuideParams";
import {IWebsitePostModel} from "../../../../../../models/website/posts/IWebsitePostModel";
import {EmptyBasicComponent} from "../../../../../components/global/empty/EmptyBasicComponent";
import {Resources} from "../../../../../../resources/Resources";

export class WebsiteContentGuideComponent extends Component {

    public headContainer: Component;
    public bodyContainer: Component;
    public titleContainer: Component;

    public headLoader: Component;
    public bodyLoader: Component;

    public guideComponent: WebsiteBlackGuideComponent;

    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent} ${r.componentWebsiteContentGuide}">
                <div class="${r.head}">
                    <div class="${r.whiteShadow}"></div>
                </div>
                <div class="${s.white} ${r.white}"></div>
            </div>
        `;
    }

    commit() {
        this.headContainer = this.el(r.head);
        this.bodyContainer = this.el(r.white);

        super.commit();
    }

    async renderAll() {
        this.renderLoader();
        let post = await WebsitePostsService.getPost(Resources.language, WebsitePostType.GUIDE, Network.router.pages.getParam(WebsiteGuideParams.BASE));
        this.removeLoader();

        if (post) {
            this.guideComponent = new WebsiteBlackGuideComponent(post.categories);
            this.bodyContainer.render(this.guideComponent);
            await this.renderContent(post);
        } else {
            //language=HTML
            this.bodyContainer.append(`
                <div class="${r.empty}">
                    ${this.bodyContainer.draw(new EmptyBasicComponent(`<div class="${r.emptyIcon}"></div>`, Resources.t("words.courseNotFoundMessage")))}
                </div>
            `);
        }
    }

    async renderContent(post?: IWebsitePostIncoming) {
        if (!post) {
            this.guideComponent.content.renderLoader();
            this.guideComponent.removeProgression();
            this.guideComponent.details.renderLoader();

            post = await WebsitePostsService.getPost(Resources.language, WebsitePostType.GUIDE, Network.router.pages.getParam(WebsiteGuideParams.BASE));
        }


        this.renderTitle(post.websitePost.title);
        this.guideComponent.content.renderContent(post.websitePost);
        this.guideComponent.renderProgression(post.nextPost, post.previousPost);
        this.guideComponent.details.renderDetails(post.websitePost);

        this.onReady(post.websitePost);
    }

    renderTitle(title: string) {
        this.removeTitle();

        //language=HTMl
        this.titleContainer = this.headContainer.append(`
            <h1 class="${r.title}">
                ${title}
            </h1>
        `, "h1");
    }

    removeTitle() {
        if (this.titleContainer) {
            this.titleContainer.remove();
            this.titleContainer = undefined;
        }
    }

    /**
     * loader
     */

    renderLoader(head?: boolean) {
        if (!this.headLoader) {
            this.removeTitle();
            //language=HTML
            this.headLoader = this.headContainer.append(`
                <div class="${r.loader}">
                    ${this.headContainer.draw(new LoaderObjectBlockComponent(true))}
                </div>
            `);
        }

        if (!head) {
            //language=HTML
            this.bodyLoader = this.bodyContainer.append(`
                <div class="${r.loader}">
                    ${this.draw(new LoaderLightComponent({width: 40, strokeWidth: 4}))}
                </div>
            `);
        }
    }

    removeLoader() {
        if (this.headLoader) {
            this.headLoader.remove();
            this.headLoader = undefined;
        }

        if (this.bodyLoader) {
            this.bodyLoader.remove();
            this.bodyLoader = undefined;
        }
    }

    onReady(post: IWebsitePostModel) {

    }
}